export default {
  FIP_ROUTE: {
    MOVIE: 'film',
    EPISODE: 'episode',
    SEASON: 'season',
    PACKAGE: 'package',
    CATEGORY: 'category'
  },

  IMAGE_TYPE: {
    COVER: 'COVER',
    BANNER: 'BANNER_1',
    COVER_16_9: 'RATIO_16_9'
  },

  RESOURCE_TYPES: {
    PACKAGE: 'PACKAGE',
    SEASON: 'SEASON',
    SERIES: 'SERIES',
    VIDEO: 'VIDEO',
    CATEGORY: 'CATEGORY',
    DISCOUNT_CATEGORY: 'DISCOUNT_CATEGORY',
    EPISODE: 'EPISODE',
    MOVIE: 'MOVIE',
    LINK: 'LINK'
  }
}
